// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Cart: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16">
            <path
                fill="currentColor"
                d="M5.47187567,13 C4.64343834,13 4.00000048,13.6715622 4.00000048,14.5 C4.00000048,15.3284378 4.67187548,16 5.47187567,16 C6.27187586,16 6.94375086,15.3284378 6.94375086,14.5 C6.94375086,13.6715622 6.32812548,13 5.47187567,13 Z M14.4718757,13 C13.6434379,13 13.0000005,13.6715622 13.0000005,14.5 C13.0000005,15.3284378 13.6715627,16 14.4718757,16 C15.2721887,16 15.9437509,15.3284378 15.9437509,14.5 C15.9437509,13.6715622 15.3281255,13 14.4718757,13 Z M17.7968755,1.39781284 C17.605969,1.14487457 17.315001,1 16.9981256,1 L3.78437567,1 L3.73750067,0.609687805 C3.66875076,0.255906105 3.35937548,0 3,0 L0.721875191,0 C0.3359375,0 0,0.335624695 0,0.721875191 C0,1.1640625 0.3359375,1.5 0.721875191,1.5 L2.35125017,1.5 L4.23500013,11.390625 C4.33125067,11.7437496 4.64062548,12 5,12 L15.2500005,12 C15.664063,12 16,11.6640625 16,11.2781248 C16,10.8343754 15.6656251,10.5 15.2500005,10.5 L5.62187529,10.5 L5.33437538,9 L15.2843742,9 C15.7306242,9 16.1231251,8.70378113 16.2459373,8.27468777 L17.9603119,2.30281258 C18.046875,1.97031212 17.9874992,1.65093803 17.796875,1.39781284 L17.7968755,1.39781284 Z M14.90625,7.5 L5.05000019,7.5 L4.09781265,2.5 L16.338438,2.5 L14.90625,7.5 Z"
            />
        </svg>
    );
};

export default React.memo(Cart);
